import * as React from 'react';

import _ from 'underscore';

import {Button} from 'shells/button/button';
import {ListView} from 'shells/list-view/list-view';
import {SearchBar} from 'shells/search-bar/search-bar';

// @ts-expect-error
import {ColumnPickerBucket} from './column-picker-bucket';
// @ts-expect-error
import {ColumnPickerField} from './column-picker-field';

import styles from './column-picker.module.css';

const COLUMN_PICKER_CUSTOM_FIELD_HEADER = 'COLUMN_PICKER_CUSTOM_FIELD_HEADER';

type Props = {
    searchValue?: string;
    buckets: any;
    bucketList: any[];
    selectedBucket: string;
    onResetFieldsToDefault: () => any;
    onSearchValueChanged: (newVal: string) => any;
    onFieldSelect: (toggledField: string) => any;
    onBucketSelect: (name: string) => any;
};

export class ColumnPicker extends React.PureComponent<Props> {
    searchBarRef: HTMLInputElement | null | undefined;

    render() {
        const isSearching = this.props.searchValue && this.props.searchValue.length;
        const columns = this.props.buckets[this.props.selectedBucket];
        const customFieldIndex = _.findIndex(columns, (col) => col.isCustomField === true);
        if (customFieldIndex !== -1) {
            columns.splice(customFieldIndex, 0, COLUMN_PICKER_CUSTOM_FIELD_HEADER);
        }

        return (
            <div className={styles.container}>
                <div className={styles['search-header']}>
                    <SearchBar
                        key='column-picker-search'
                        value={this.props.searchValue}
                        searchBarRef={(c) => {
                            this.searchBarRef = c;
                        }}
                        onChange={this.props.onSearchValueChanged}
                        placeholder='Search for a column…'
                        autoFocus={true}
                        isClearable={true}
                    />
                </div>
                <div className={styles['bucket-list']}>
                    <ListView
                        collection={this.props.bucketList}
                        renderRow={(bucket) =>
                            renderBucket(
                                bucket,
                                this.props.selectedBucket,
                                this.handleBucketSelected
                            )
                        }
                    />
                    <Button
                        size='big'
                        variant='text-primary'
                        onClick={this.props.onResetFieldsToDefault}
                    >
                        Restore default columns
                    </Button>
                </div>
                <div className={styles['column-list']}>
                    <ListView
                        collection={columns}
                        shouldfadeBottom={true}
                        renderRow={(field) =>
                            renderField(field, this.props.onFieldSelect, isSearching)
                        }
                    />
                </div>
            </div>
        );
    }

    handleBucketSelected = (newBucketName: string) => {
        this.props.onBucketSelect(newBucketName);
        if (this.searchBarRef) {
            this.searchBarRef.focus();
        }
    };
}

/*
 * Render functions for ListViews
 */

// @ts-expect-error
function renderBucket(bucket, selectedBucket, onBucketSelect) {
    const isBucketSelected = bucket.name.toLowerCase() === selectedBucket.toLowerCase();

    return (
        <ColumnPickerBucket
            key={bucket.name}
            bucket={bucket}
            isSelected={isBucketSelected}
            onSelect={() => onBucketSelect(bucket.name)}
        />
    );
}

// @ts-expect-error
function renderField(column, onFieldSelect, isSearching) {
    if (column === COLUMN_PICKER_CUSTOM_FIELD_HEADER) {
        return (
            <li
                key='customFieldHeader'
                className='ui-row ui-row__header ui-row__header-custom-fields'
            >
                <span className='ui-header-name'>Custom fields</span>
            </li>
        );
    }
    const showSubtitle = isSearching && column.subtitle && column.subtitle.length;

    return (
        <ColumnPickerField
            key={column.name}
            column={column}
            showSubtitle={showSubtitle}
            onSelect={() => onFieldSelect(column.name)}
        />
    );
}
